import React from 'react';
import { Spinner } from '../../components/ui';
import { fmtDate, fmtTime } from '../../utils/helpers';

// Desktop Headcount — one table as wide as its numbers (no stretched columns),
// numbers right-aligned so they compare at a glance, totals in the footer.
export default function HeadcountDesktop({ vm }) {
  const { loading, perFunction, grand, isTwoSided } = vm;
  return (
    <div>
      <div className="page-head"><h1>Headcount</h1></div>
      <div className="ev-hc-intro">
        Expected persons per function — give these to the venue owner for catering / dinner.
        Parties are deduped by mobile, so a family invited by several members counts once. Private guests are included.
      </div>
      {loading ? <Spinner /> : (
        <div className="card table-wrap">
          <table className="tbl ev-hc-tbl">
            <thead>
              <tr>
                <th>Function</th><th>Date</th><th className="num">Parties</th><th className="num">Persons</th>
                {isTwoSided && <><th className="num">Groom side</th><th className="num">Bride side</th><th className="num">Common</th></>}
              </tr>
            </thead>
            <tbody>
              {perFunction.map(({ fn, parties, persons, extra, extraCards, bySide }) => (
                <tr key={fn.FunctionId} className="row-link" title="Open guests of this function" onClick={() => vm.openRow(fn)}>
                  <td><strong>{fn.FunctionName}</strong></td>
                  <td>{fmtDate(fn.FunctionDate)}{fn.FunctionTime ? <span className="muted"> · {fmtTime(fn.FunctionTime)}</span> : ''}</td>
                  <td className="num">{parties}</td>
                  <td className="num ev-hc-persons">
                    {extra > 0 && <span className="muted" style={{ fontSize: 12 }}>(incl. {extra} on {extraCards} extra cards) </span>}
                    <strong>{persons}</strong>
                  </td>
                  {isTwoSided && <><td className="num">{bySide.Groom}</td><td className="num">{bySide.Bride}</td><td className="num">{bySide.Common}</td></>}
                </tr>
              ))}
              {perFunction.length === 0 && <tr><td colSpan={isTwoSided ? 7 : 4} className="empty">No functions yet.</td></tr>}
            </tbody>
            {perFunction.length > 0 && (
              <tfoot>
                <tr>
                  <td colSpan={2}><strong>All functions</strong></td>
                  <td className="num"><strong>{grand.parties}</strong></td>
                  <td className="num ev-hc-persons"><strong>{grand.persons}</strong></td>
                  {isTwoSided && <td colSpan={3} className="muted ev-hc-note">person-visits (someone invited to both counts in each)</td>}
                </tr>
              </tfoot>
            )}
          </table>
        </div>
      )}
    </div>
  );
}
